<h2 id="CloudToolbarTitle">{{ appTitle | async }}</h2>
